import { Input, Modal } from 'antd'
import { useEffect, useState } from 'react'

interface DeleteEventModalProps {
  visible: boolean
  eventName: string
  isDeleting: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function DeleteEventModal({
  visible,
  eventName,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteEventModalProps) {
  const [confirmation, setConfirmation] = useState('')

  useEffect(() => {
    if (visible) setConfirmation('')
  }, [visible])

  return (
    <Modal
      title="Permanently Delete Event"
      open={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Delete Event"
      cancelText="Cancel"
      confirmLoading={isDeleting}
      okButtonProps={{ danger: true, disabled: confirmation !== eventName }}
      cancelButtonProps={{ disabled: isDeleting }}
      maskClosable={!isDeleting}
      closable={!isDeleting}
    >
      <p className="text-sm text-[rgba(0,0,0,0.65)]">
        This permanently deletes <strong>{eventName}</strong>, including attendees,
        registrations, reports, files, and all other associated data.
      </p>

      <div className="mt-4 rounded-sm border border-red-200 bg-red-50 p-4">
        <p className="mb-1 text-sm font-medium text-red-700">This cannot be undone.</p>
        <p className="text-sm text-red-600">
          Type the event name exactly to enable permanent deletion.
        </p>
      </div>

      <Input
        className="mt-4"
        value={confirmation}
        onChange={(event) => setConfirmation(event.target.value)}
        placeholder={eventName}
        disabled={isDeleting}
        autoComplete="off"
      />
    </Modal>
  )
}
